<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormBadge }}</h2>

        <div class="mb-3">
            {{ store.lexicon[store.culture].PRFormBadge1 }}
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormBadge2 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Access.BadgeholderName" @input="validatePage('Access', 'badgeholderName')" />
                <div v-if="store.errors.Access.BadgeholderName" class="error">{{ store.lexicon[store.culture].PRFormBadge3 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormBadge4 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Access.BadgeNumber" @input="validatePage('Access', 'badgeNumber')" />
                <div v-if="store.errors.Access.BadgeNumber" class="error">{{ store.lexicon[store.culture].PRFormBadge5 }}</div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>UPID: <span class="required">*</span> {{ store.lexicon[store.culture].PRFormBadge6 }}</label>
                <input type="text" class="form-control" v-model="store.formData.Access.Upid" @input="validatePage('Access', 'upid')" />
                <div v-if="store.errors.Access.Upid" class="error">{{ store.lexicon[store.culture].PRFormBadge7 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormBadge8 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Access.DatesAndTimes" @input="validatePage('Access', 'datesAndTimes')" />
                <div v-if="store.errors.Access.DatesAndTimes" class="error">{{ store.lexicon[store.culture].PRFormBadge9 }}</div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12">
                <label>{{ store.lexicon[store.culture].PRFormBadge10 }} <span class="required">*</span></label>
                <textarea type="text" class="form-control" v-model="store.formData.Access.Details" @input="validatePage('Access', 'details')"></textarea>
                <div v-if="store.errors.Access.Details" class="error">{{ store.lexicon[store.culture].PRFormBadge11 }}</div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.currentTypePage == 0 ? goBackToPage('TYPE') : goBackToTypePage(store.currentTypePage - 1)">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="store.currentTypePage == store.formData.Types.length - 1 ? goToPage('FINISH') : goToTypePage(store.currentTypePage + 1)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage', 'goBackToTypePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }

</script>